import {Component, ElementRef, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation, EventEmitter} from '@angular/core';
import * as _ from 'lodash';
import {NetworkApiService} from '../../../services/api/network/online/network/network-api.service';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {animate, style, transition, trigger} from '@angular/animations';
import {NetworkMapApiService} from '../../services/map/network-map-api/network-map-api.service';
import {DataCacheApiService} from '../../services/map/data-cache-api/data-cache-api.service';
import {ConfirmationDialogComponent} from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {DataItemToVisualsMappersOfflineService} from '../../services/offline-map/data-item-to-visuals-mappers-offline/data-item-to-visuals-mappers-offline.service';
import {OfflineNetworkApiService} from '../../../services/api/network/offline/network/offline-network-api.service';
import {OfflineNetworkLayersService} from '../../services/offline-map/offline-network-layers-service/offline-network-layers.service';
import {OfflineMapApiService} from '../../services/offline-map/offline-map-api/offline-map-api.service';
import {ContextMenuComponent} from '@perfectmemory/ngx-contextmenu';
import {OfflineDiagramContextMenuService} from '../../services/offline-map/offline-diagram-context-menu/offline-diagram-context-menu.service';
import {OfflineMapService} from '../../services/map/offline-map/offline-map.service';

@Component({
  selector: 'offline-map-diagram',
  templateUrl: './offline-map-diagram.component.html',
  styleUrls: ['./offline-map-diagram.component.less'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger(
      'inOutAnimation',
      [
        transition(
          ':enter',
          [
            style({opacity: 0}),
            animate('0.3s ease-out',
              style({opacity: 1}))
          ]
        ),
        transition(
          ':leave',
          [
            style({opacity: 1}),
            animate('0.3s ease-in',
              style({opacity: 0}))
          ]
        )
      ]
    )
  ]
})
export class OfflineMapDiagramComponent implements OnInit, OnDestroy {

  constructor(private dataItemToVisualsMappersOfflineService: DataItemToVisualsMappersOfflineService,
              private offlineDiagramContextMenuService: OfflineDiagramContextMenuService,
              private userPrivilege: UserPrivilegeService,
              private offlineNetworkApiService: OfflineNetworkApiService,
              private networkMapApiService: NetworkMapApiService,
              private networkApiService: NetworkApiService,
              private offlineNetworkLayers: OfflineNetworkLayersService,
              private dataCacheApiService: DataCacheApiService,
              private offlineMapApiService: OfflineMapApiService,
              private offlineMapService: OfflineMapService,
              public dialog: MatDialog) {
  }

  @ViewChild(ContextMenuComponent, {static: false}) public basicMenu: ContextMenuComponent;
  // @ViewChild(InnerLoaderComponent, {static: true}) innerLoaderComponent;

  @Input() diagramApi: any;
  @Output() diagramApiChange = new EventEmitter();

  @Output() diagramItemAdded = new EventEmitter();
  @Output() edgeDragged = new EventEmitter();
  @Output() onDiagramSelect = new EventEmitter();

  initialSession: any;
  rightClickedElement: any;
  isAuthorizedUser: boolean;
  contextMenuData: any;
  peerConnectionSubMenuData: any = null;

  parameters: any = {};
  offsetX: any = 0;
  offsetY: any = 0;

  testRouteObservable;

  addItemsMenu: any = {
    addNodeContainerOpen: false,
    addVoipPeerContainerOpen: false,
    isAddItemsMenuOpen: false
  };

  selectedLayersObject: any = {};

  draggable = {
    // note that data is handled with JSON.stringify/JSON.parse
    // only set simple data or POJO's as methods will be lost
    effectAllowed: 'all',
    disable: false,
    handle: false
  };

  draggedItems: any = {
    nodes: [
      {svg: 'sbc', productType: 'SBC', displayName: 'SBC', type: 'node'},
      {svg: 'gw', productType: 'GW', displayName: 'Gateway', type: 'node'},
      {svg: 'hybrid', productType: 'HYBRID', displayName: 'Hybrid', type: 'node'},
      {svg: 'thirdParty', productType: 'THIRD_PARTY', displayName: 'Third party node', type: 'thirdPartyDevice'}
    ],
    voippeers: [
      {svg: 'ip', deviceType: 'IP_PHONES', displayName: 'IP phones', type: 'voippeer'},
      {svg: 'sip', deviceType: 'SIP_TRUNK', displayName: 'SIP Trunk', type: 'voippeer'},
      {svg: 'ip_pbx', deviceType: 'IP_PBX', displayName: 'IP PBX', type: 'voippeer'},
      {svg: 'pbx', deviceType: 'PBX', displayName: 'PBX', type: 'voippeer'},
      {svg: 'pstn', deviceType: 'PSTN', displayName: 'PSTN', type: 'voippeer'},
      {svg: 'teams', deviceType: 'TEAMS', displayName: 'TEAMS', type: 'voippeer'}
    ],
    item: {}
  };

  savedMapConfigurations: any;

  @ViewChild('offlineDiagram', {static: false}) onlineDiagramElem: ElementRef;

  onDrop($event): void {
    this.closeAddItemMenu();
    this.draggedItems.item = $event.data;
    this.offsetX = $event.event.offsetX - 25 + 'px';
    this.offsetY = $event.event.offsetY - 25 + 'px';
    const coordinates = this.diagramApi.domToCanvasTranslate($event.event.offsetX, $event.event.offsetY);

    const isNode = ($event.data.type === 'aCDevice' || $event.data.type === 'thirdPartyDevice');

    if ($event.data.type === 'node' || $event.data.type === 'thirdPartyDevice') {
      /*this.sharedEventService.broadcast('offlineDiagramItemAdded',
        {x: coordinates.x, y: coordinates.y, type: $event.data.type, productType: $event.data.productType});*/
      this.diagramItemAdded.emit({
        x: coordinates.x,
        y: coordinates.y,
        type: $event.data.type,
        productType:
        $event.data.productType
      });
    } else {
      /*this.sharedEventService.broadcast('offlineDiagramItemAdded',
        {x: coordinates.x, y: coordinates.y, type: $event.data.type, deviceType: $event.data.deviceType});*/
      this.diagramItemAdded.emit({
        x: coordinates.x,
        y: coordinates.y,
        type: $event.data.type,
        deviceType:
        $event.data.deviceType
      });
    }
  }

  ngOnInit(): void {
    this.initialSession = !_.isEqual(sessionStorage.getItem('offline-diagram-session'), 'true');
    this.isAuthorizedUser = this.userPrivilege.isAuthorized();
    this.initializeMapConfigurations();
    this.testRouteObservable = this.offlineMapService.onTestRoute().subscribe(() => {
      this.unselectAllElementsOfNetwork();
    });

    this.resetLayersSelection();
  }


  scopeDestroyForBroadcasts = () => {
  }

  ngOnDestroy(): void {
    this.scopeDestroyForBroadcasts();
    this.testRouteObservable.unsubscribe();
  }

  stopPropagation(event): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onDiagramReady(diagramApiLocal): void {
    // wait until cache data is ready
    /*let dataReady: boolean = this.dataCacheApiService.getDataReady().value;
    if (dataReady === true) {
      this.initDiagram(diagramApiLocal);
    } else {
      this.dataCacheApiService.getDataReady().pipe(takeWhile(() => dataReady === false)).subscribe(x => {
        if (x === true) {
          dataReady = true;
          this.initDiagram(diagramApiLocal);
        }
      });
    }*/

    this.diagramApi = diagramApiLocal;
    this.diagramApiChange.emit(this.diagramApi);
    if (this.initialSession) {
      this.initializeDiagramWithData(true);
      sessionStorage.setItem('offline-diagram-session', 'true');
    } else {
      this.initializeDiagramWithData(false);
    }

  }

  initDiagram(diagramApiLocal): void {
    this.diagramApi = diagramApiLocal;
    /*this.sharedEventService.broadcast('onlineDiagramReady', this.diagramApi);*/
    this.diagramApiChange.emit(this.diagramApi);

    if (this.initialSession) {
      this.initializeDiagramWithData(true);
      sessionStorage.setItem('online-diagram-session', 'true');
    } else {
      this.initializeDiagramWithData(false);
    }
    // this.innerLoaderComponent.showContent();
  }

  onSelect($event): void {
    // this.sharedEventService.broadcast('onlineDiagramSelectionChanged', $event.nodes, $event.edges);
    this.onDiagramSelect.emit($event);
  }

  onEdgeDragged($event): void {
    // this.sharedEventService.broadcast('onlineDiagramEdgeDragged', $event.draggedEdgeObject);
    this.edgeDragged.emit($event.draggedEdgeObject);
  }

  onContextMenu($event): void {
    if (_.isNil($event.contextMenuObject.element)) { return; }

    this.rightClickedElement = $event.contextMenuObject.element;
    this.contextMenuData = this.offlineDiagramContextMenuService.prepareContextMenuActions(this.diagramApi,
      this.rightClickedElement);

    this.peerConnectionSubMenuData = this.rightClickedElement.connectionType === 'peerConnection' ?
      this.offlineDiagramContextMenuService.prepareLockPeerConnectionSubMenu(this.rightClickedElement) : null;
  }

  getClusteredEdgePropertiesByEdges = (edgesInCluster) => {
    return this.dataItemToVisualsMappersOfflineService.getClusteredEdgeProperties(edgesInCluster);
  }

  getClusteredNodePropertiesByNodes = (nodesInCluster) => {
    return this.dataItemToVisualsMappersOfflineService.getClusteredNodeProperties(nodesInCluster);
  }

  onDiagramClick(event): void {

  }

  onDragStart(event): void {

  }

  closeAllContainersScope(): void {
    this.closeAllContainers();
  }

  updateMapConfigurations(): void {
    localStorage.setItem('MapConfigurations_offline', JSON.stringify(this.savedMapConfigurations));
    this.diagramApi.updateMapConfigurations(this.savedMapConfigurations);

    if (!_.isEqual(this.dataItemToVisualsMappersOfflineService.getLabelOptions(), this.savedMapConfigurations.labelOptions)) {
      this.dataItemToVisualsMappersOfflineService.setLabelOptions(this.savedMapConfigurations.labelOptions);
      this.updateDiagramData();
      this.updateDiagramClusters();
    }

  }

  bringIntoView(): void {
    this.diagramApi.fit();
  }

  sendItemsLocationToServer(): void {
    const draggedElements = this.prepareDraggedObjects();
    const clusters = this.diagramApi.getData().clusters;

    this.offlineMapApiService.updateShapesLocation(draggedElements, clusters)
      .then(() => {
        this.offlineNetworkApiService.clearOfflineMapData();
        this.initializeDiagramWithData(true);
      });
  }

  updateDiagramData(): void {
    this.offlineNetworkApiService.getOfflineMap().subscribe((map) => {
      this.fetchData().then(data => {
        this.diagramApi.updateData(data.nodes, data.edges);
      });
    });
  }

  isSendItemsLocationToServerEnabled(): boolean {
    return this.diagramApi && (this.diagramApi.doShapesDragged() || this.diagramApi.doesClustersStateChanged());
  }

  unselectAllElementsOfNetwork(): void {
    this.diagramApi.unselectAll();
  }

  prepareDraggedObjects(): any {
    const draggedElements = {nodes: [], voipPeers: []};
    const currentLocations = this.diagramApi.getElementsLocation();
    const diagramElements = this.diagramApi.getData().nodesArray;

    diagramElements.forEach((element) => {
      if (element.shapeType === 'node') {
        if (element.dataItem.x !== currentLocations[element.id].x || element.dataItem.y !== currentLocations[element.id].y) {
          draggedElements.nodes.push({
            id: element.dataItem.id,
            x: currentLocations[element.id].x,
            y: currentLocations[element.id].y
          });
        }
      } else if (element.shapeType === 'voipPeer') {
        if (element.dataItem.x !== currentLocations[element.id].x || element.dataItem.y !== currentLocations[element.id].y) {
          draggedElements.voipPeers.push({
            id: element.dataItem.id,
            x: currentLocations[element.id].x,
            y: currentLocations[element.id].y
          });
        }
      }
    });

    return draggedElements;
  }

  fetchData(): any {
    return Promise.all([this.offlineMapApiService.getDataForShapes(this.parameters),
      this.offlineMapApiService.getDataForConnections(this.parameters),
      this.offlineNetworkApiService.getClusters().toPromise()
    ]).then(data => {
      return {
        nodes: data[0],
        edges: data[1],
        clusters: data[2]
      };
    });
  }

  initializeDiagramWithData(overrideLocationsAndClusters): void {
    this.offlineNetworkApiService.getOfflineMap().subscribe(() => {
      this.fetchData().then(data => {
        if (overrideLocationsAndClusters) {
          this.diagramApi.setData(data.nodes, data.edges, data.clusters, true);
        } else {
          this.diagramApi.setData(data.nodes, data.edges, undefined, false);
        }
      });
    });
  }

  manualRefresh(): void {
    if (this.diagramApi && this.diagramApi.doShapesDragged()) {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '460px',
        data: {
          message: `Unsaved items location will be reset" ?`
        }
      });

      dialogRef.componentInstance.onApply.subscribe(result => {
        this.initializeDiagramWithData(true);
        dialogRef.close();
      });
    } else {
      this.initializeDiagramWithData(true);
    }
  }

  removeDraggedSvg(): void {
    this.draggedItems.item = {};
  }

  closeAddItemMenu(): void {
    this.closeAllContainers();
    this.addItemsMenu.isAddItemsMenuOpen = false;
  }

  closeAllContainers(): void {
    this.addItemsMenu.addNodeContainerOpen = false;
    this.addItemsMenu.addVoipPeerContainerOpen = false;
  }

  searchRefresh(searchObject): void {
    if (searchObject === '') {
      this.offlineNetworkApiService.clearOfflineMapData();
    }
    this.parameters.searchObject = searchObject;
    this.parameters.mapFilter = true;
    this.updateDiagramData();
  }

  initializeMapConfigurations(): void {
    const conf = localStorage.getItem('MapConfigurations_offline');
    const savedMapConfigurations = conf ? JSON.parse(conf) : {};

    this.savedMapConfigurations = _.merge(
      {},
      {
        advancedConfigurations: {drawAnimated: false},
        visjs: {interaction: {hideEdgesOnDrag: false}},
        labelOptions: {shorten: false, length: 255}
      },
      savedMapConfigurations
    );

    this.dataItemToVisualsMappersOfflineService.setLabelOptions(this.savedMapConfigurations.labelOptions);
  }

  updateMapWithLayers(): void {
    this.offlineNetworkLayers.setSelectedLayers(this.selectedLayersObject);
    // this.sharedEventService.broadcast('OnlineDiagramPeriodicRefresh');
    this.updateDiagramData();
  }

  resetLayersSelection(): void {
    this.selectedLayersObject = this.offlineNetworkLayers.getSelectedLayers();
  }

  private updateDiagramClusters(): void {
    const clusters = this.diagramApi.getData().clusters;
    const updatedClusters = this.dataItemToVisualsMappersOfflineService.prepareClustersPropertiesForDiagram(clusters);

    this.diagramApi.updateClusters(updatedClusters);
  }

  private setParametersAndFilter(searchObject): void {
    this.parameters.searchObject = searchObject;
    this.parameters.mapFilter = true;
    this.updateDiagramData();
  }
}
